module.exports = __webpack_public_path__ + "static/media/about-illustration-1.89f28fe9.svg";